// src/pages/client/Oportunidades.jsx
// Página /oportunidades — Hub + Vista de partido + Detalle de tendencias
// pre-partido NBA/WNBA. Solo para usuarios con plan activo (enforce vía
// ProtectedRoute + hasActiveAccess en App.jsx).
//
// Layout idéntico a Aprende/ComoFunciona: Sidebar + Topbar + main.
// Hereda dark/light del DashboardThemeProvider y se lo pasa al componente
// trends como themeOverride para que NO muestre su propio toggle.
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ref, onValue } from 'firebase/database';
import { db } from '../../firebase';
import { useAuth } from '../../auth/AuthContext';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import { DashboardThemeProvider, useDashboardTheme } from '../../theme/DashboardTheme';
import EdgeEliteTrends from '../../components/oportunidades/EdgeEliteTrends';
import '../../index.css';

function OportunidadesContent() {
  const { theme } = useDashboardTheme();
  return (
    <div style={{ padding: '0 0 24px', minHeight: 'calc(100vh - 56px)' }}>
      <EdgeEliteTrends themeOverride={theme} />
    </div>
  );
}

export default function Oportunidades() {
  const navigate = useNavigate();
  const { user, userData } = useAuth();
  const [picks, setPicks] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [connected, setConnected] = useState(true);

  // Listener de /picks SOLO para alimentar las chips de liga del Sidebar
  // (consistente con Aprende.jsx). No se usa en el contenido de la página.
  useEffect(() => {
    const picksRef = ref(db, 'picks');
    const unsub = onValue(
      picksRef,
      (snap) => {
        const data = snap.val() || {};
        const list = Object.entries(data).map(([id, p]) => ({ id, ...(p || {}) }));
        setPicks(list);
        setConnected(true);
      },
      () => setConnected(false)
    );
    return () => unsub();
  }, []);

  function handleNav(p, league) {
    if (p === 'live') navigate('/dashboard');
    else if (p === 'signals') navigate('/historial');
    else if (p === 'como-funciona') navigate('/como-funciona');
    else if (p === 'recomendaciones') navigate('/recomendaciones');
    else if (p === 'aprende') navigate('/aprende');
    else if (p === 'oportunidades') navigate('/oportunidades');
    else navigate('/dashboard');
  }

  return (
    <DashboardThemeProvider>
      <div className="app-layout app dashboard-scoped">
        <Helmet>
          <title>Oportunidades · Edge Elite</title>
        </Helmet>

        <Sidebar
          page="oportunidades"
          setPage={(p) => handleNav(p)}
          selectedLeague="all"
          setLeague={(l) => handleNav('live', l)}
          picks={picks}
          user={user}
          userData={userData}
          isAdmin={false}
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />

        <div className="main-content main">
          <Topbar
            connected={connected}
            lastUpdate={null}
            getAgeStr={() => '—'}
            getAgeColor={() => 'var(--muted)'}
            onMenuOpen={() => setSidebarOpen(true)}
            picks={picks}
          />
          <OportunidadesContent />
        </div>
      </div>
    </DashboardThemeProvider>
  );
}
